var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ApplicationContainer"},[(!_vm.initialized)?_c('InitializeApp'):_c('RouterView'),_c('NotificationContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }